export const InfoPanel: React.FC<{
    title: string;
    right?: React.ReactNode;
    children: React.ReactNode;
}> = ({ title, right, children }) => {
    return (
        <div className="p-3 bg-slate-50 rounded-lg border border-slate-200">
            <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-slate-600">{title}</span>
                {right}
            </div>
            {children}
        </div>
    );
};